<ion-content class="ion-padding">
    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <ion-label class="ion-text-center ion-text-wrap">
                {{ getText(processConfig?.globalizationConfig, 'title') | uppercase }}
            </ion-label>
        </ion-item>

        <app-step-description
                [description]="getText( processConfig?.globalizationConfig, 'instructions' )"
                [employee]="{
                    imageUrl: getImageUrl(subordinateGoals?.employeeImageUrl),
                    username: subordinateGoals?.employee
                  }"
        ></app-step-description>

        <ion-card mode="ios" class="card-table-data">
            <ion-grid>
                <ion-row>
                    <ion-col>
                    <ion-list class="inputs-progress">
                        <ion-list-header>
                            <ion-label>{{ 'goalsInput.totalWeight' | translate }}: {{ getTotalWeight() }}% / 100%
                            </ion-label>
                        </ion-list-header>
                        <ion-progress-bar [value]="getTotalWeight() / 100"></ion-progress-bar>
                    </ion-list>
                    </ion-col>
                    <ion-col>
                    <ion-card-header *ngIf="canApproveGoals(subordinateGoals?.goals) && stepStatus !== ProcessStatusEnum.AllowedViewing" goRight>
                        <ion-button mode="ios" color="secondary" (click)="openNewGoalModal()">
                            {{ 'goalsValidation.newGoal' | translate }}
                        </ion-button>
                    </ion-card-header>
                    </ion-col>
                </ion-row>
            </ion-grid>

            <ion-card-content class="ion-no-padding">
                <ion-grid class="table-view">
                    <ion-row hidden-mobile class="header">
                        <ion-col
                                *ngIf="processConfig?.title || processConfig?.description"
                                size-md="4">
                            {{ 'generic.goal' | translate }}
                        </ion-col>
                        <ion-col *ngIf="processConfig?.weight" [sizeMd]="getColumnSize(processConfig?.questions.length)">
                            {{ 'generic.weight' | translate }}
                        </ion-col>
                        <ion-col *ngIf="processConfig?.deadline" [sizeMd]="getColumnSize(processConfig?.questions.length)">
                            {{ 'generic.deadline' | translate }}
                        </ion-col>
                        <ng-container *ngIf="processConfig?.questions">
                            <ion-col
                                    [sizeMd]="getColumnSize(processConfig?.questions.length)"
                                    *ngFor="let question of processConfig?.questions">
                                {{ getText(question.globalizationConfig, 'title') }}
                            </ion-col>
                        </ng-container>
                        <ion-col [sizeMd]="getColumnSize(processConfig?.questions.length)">
                            {{ 'generic.validation' | translate }}
                        </ion-col>
                    </ion-row>

                    <ion-row *ngFor="let goal of displayedGoals">
                        <!-- Previous Changes -->
                        <ng-container *ngIf="goal.lastVersion">
                            <ion-col
                                    *ngIf="processConfig?.title || processConfig?.description"
                                    size="12"
                                    size-md="4"
                                    faded>
                                <div class="content">
                                    <p class="label-heading" hidden-desktop>
                                        {{ 'generic.goal' | translate }}
                                    </p>
                                    <h2>{{ goal.lastVersion.title }}</h2>
                                    <p class="underline-text">
                                        {{ goal.lastVersion.description }}
                                    </p>
                                </div>
                            </ion-col>
                            <ion-col
                                    *ngIf="processConfig?.weight"
                                    class="ion-align-self-center"
                                    [sizeMd]="getColumnSize(processConfig?.questions.length)"
                                    faded
                            >
                                <p class="label-heading" hidden-desktop>
                                    {{ 'generic.weight' | translate }}
                                </p>
                                {{ goal.lastVersion.weight }}%
                            </ion-col>
                            <ion-col
                                    *ngIf="processConfig?.deadline"
                                    class="ion-align-self-center"
                                    [sizeMd]="getColumnSize(processConfig?.questions.length)"
                                    faded
                            >
                                <p class="label-heading" hidden-desktop>
                                    {{ 'generic.deadline' | translate }}
                                </p>
                                {{ goal.lastVersion.deadline | date : 'dd/MM/yyyy' }}
                            </ion-col>
                            <ng-container *ngIf="processConfig?.questions">
                                <ion-col
                                        class="ion-align-self-center"
                                        faded
                                        [sizeMd]="getColumnSize(processConfig?.questions.length)"
                                        *ngFor="let question of processConfig?.questions; let index = index">
                                    <p class="label-heading" hidden-desktop>
                                        {{ getText(question.globalizationConfig, 'title') }}
                                    </p>
                                    <ng-container
                                            *ngIf="question.typeConfig.type === QuestionType.Date || question.typeConfig.type === QuestionType.Deadline">
                                        {{
                                            goal.lastVersion['field' + (index + 1)] | translate |
                                                    date:'dd/MM/yyyy'
                                        }}
                                    </ng-container>
                                    <ng-container
                                            *ngIf="question.typeConfig.type === QuestionType.Weight">
                                        {{ goal.lastVersion['field' + (index + 1)] | translate }} %
                                    </ng-container>
                                    <ng-container
                                            *ngIf="question.typeConfig.type !== QuestionType.Date &&
                                                      question.typeConfig.type !== QuestionType.Weight &&
                                                      question.typeConfig.type !== QuestionType.Deadline">
                                        {{
                                            question.typeConfig?.possibleValuesGlobalized &&
                                            question.typeConfig?.possibleValuesGlobalized[selectedLanguage]?.length > 0 &&
                                            question.typeConfig?.possibleValues &&
                                            question.typeConfig?.possibleValues?.length > 0
                                                    ?
                                                    question.typeConfig?.possibleValuesGlobalized[selectedLanguage][question.typeConfig?.possibleValues.indexOf(goal.lastVersion['field' + (index + 1)])]
                                                    :
                                                    (goal.lastVersion['field' + (index + 1)] | translate)
                                        }}
                                    </ng-container>
                                </ion-col>
                            </ng-container>
                            <ion-col
                                        class="ion-align-self-center"
                                            faded
                                        [sizeMd]="getColumnSize(processConfig?.questions.length)">
                                <p><b>{{ 'generic.beforeEditing' | translate }}</b></p>
                            </ion-col>
                        </ng-container>
                        <!-- Current Goal -->
                        <ion-col
                                *ngIf="processConfig?.title || processConfig?.description"
                                size-md="4"
                        >
                            <div class="content">
                                <p class="label-heading" hidden-desktop>
                                    {{ 'generic.goal' | translate }}
                                </p>
                                <h2>{{ goal.title }}</h2>
                                <p class="underline-text">{{ goal.description }}</p>
                            </div>
                        </ion-col>
                        <ion-col
                                *ngIf="processConfig?.weight"
                                class="ion-align-self-center"
                                [sizeMd]="getColumnSize(processConfig?.questions.length)"
                        >
                            <p class="label-heading" hidden-desktop>
                                {{ 'generic.weight' | translate }}
                            </p>
                            {{ goal.weight }}%
                        </ion-col>
                        <ion-col
                                *ngIf="processConfig?.deadline"
                                class="ion-align-self-center"
                                [sizeMd]="getColumnSize(processConfig?.questions.length)"
                        >
                            <p class="label-heading" hidden-desktop>
                                {{ 'generic.deadline' | translate }}
                            </p>
                            {{ goal.deadline | date : 'dd/MM/yyyy' }}
                        </ion-col>
                        <ng-container *ngIf="processConfig?.questions">
                            <ion-col
                                    class="ion-align-self-center"
                                    [sizeMd]="getColumnSize(processConfig?.questions.length)"
                                    *ngFor="let question of processConfig?.questions; let index = index"
                            >
                                <p class="label-heading" hidden-desktop>
                                    {{ getText(question.globalizationConfig, 'title') }}
                                </p>
                                <ng-container
                                        *ngIf="question.typeConfig.type === QuestionType.Date || question.typeConfig.type === QuestionType.Deadline"
                                >
                                    {{
                                        goal['field' + (index + 1)] | translate | date:'dd/MM/yyyy'
                                    }}
                                </ng-container>
                                <ng-container
                                        *ngIf="question.typeConfig.type === QuestionType.Weight"
                                >
                                    {{ goal['field' + (index + 1)] | translate }} %
                                </ng-container>
                                <ng-container
                                        *ngIf="question.typeConfig.type !== QuestionType.Date &&
                                                question.typeConfig.type !== QuestionType.Weight &&
                                                question.typeConfig.type !== QuestionType.Deadline">
                                    {{
                                        question.typeConfig?.possibleValuesGlobalized &&
                                        question.typeConfig?.possibleValuesGlobalized[selectedLanguage]?.length > 0 &&
                                        question.typeConfig?.possibleValues &&
                                        question.typeConfig?.possibleValues?.length > 0
                                                ?
                                                question.typeConfig?.possibleValuesGlobalized[selectedLanguage][question.typeConfig?.possibleValues.indexOf(goal['field' + (index + 1)])]
                                                :
                                                (goal['field' + (index + 1)] | translate)
                                    }}
                                </ng-container>
                            </ion-col>
                        </ng-container>
                        <ion-col
                                class="ion-align-self-center"
                                [sizeMd]="getColumnSize(processConfig?.questions.length)"
                        >
                            <div
                                    class="buttons-action"
                                    *ngIf="canApproveGoals(subordinateGoals?.goals)"
                            >
                                <ion-button
                                        fill="clear"
                                        mode="ios"
                                        [color]="goal.approved === false ? 'danger' : 'gray'"
                                        (click)="goal.approved = false"
                                        [disabled]="stepStatus === ProcessStatusEnum.AllowedViewing">
                                    <ion-icon class="bp-not-accepted-circle"></ion-icon>
                                </ion-button>
                                <ion-button
                                        fill="clear"
                                        mode="ios"
                                        [color]="goal.approved === true ? 'success' : 'gray'"
                                        (click)="goal.approved = true"
                                        [disabled]="stepStatus === ProcessStatusEnum.AllowedViewing">
                                    <ion-icon class="bp-check-circle"></ion-icon>
                                </ion-button>
                                <ion-button
                                        class="edit"
                                        color="primary"
                                        fill="clear"
                                        mode="ios"
                                        (click)="openManageGoalsInputModal(goal)"
                                        *ngIf="stepStatus !== ProcessStatusEnum.AllowedViewing">
                                    <ion-icon class="bp-edit"></ion-icon>
                                </ion-button>
                            </div>
                            <div class="goalView"
                                 *ngIf="!canApproveGoals(subordinateGoals?.goals)">
                                <a (click)="viewGoalProgress(goal)">
                                    {{ 'dashboard.See' | translate }}
                                </a>
                            </div>
                        </ion-col>
                        <ion-col *ngIf="goal.approved === false">
                            <ion-item lines="none" feedback>
                                <ion-label color="danger" position="stacked">
                                    Feedback
                                </ion-label>
                                <ion-textarea
                                        [placeholder]="'goalsValidation.rejectionInputPlaceholder' | translate"
                                        [(ngModel)]="goal.managerComment"></ion-textarea>
                            </ion-item>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-card-content>
        </ion-card>

        <ng-container *ngIf="canApproveGoals(subordinateGoals?.goals) && stepStatus !== ProcessStatusEnum.AllowedViewing">
            <div class="bottom-buttons ion-text-right">
                <ion-button
                        mode="ios"
                        color="secondary"
                        class="send"
                        (click)="setGoalsFeedbacks(subordinateGoals.goals)">
                    {{ 'generic.finish' | translate }}
                </ion-button>
            </div>
        </ng-container>
    </div>
</ion-content>
